module.exports = __webpack_public_path__ + "img/99e5ce56ccb1416dc76ab033c5c6f358.c1dd5cb1.png";